// extracted by mini-css-extract-plugin
export default {"Backdrop":"Backdrop_Backdrop__pA82Z","opened":"Backdrop_opened__v0FDG","closed":"Backdrop_closed__GmDT5"};